export const MetabolicGauge = ({ bt }) => {
  const pct = Math.max(0, Math.min(1, bt));
  const color = pct > 0.66 ? "#10B981" : pct > 0.33 ? "#F59E0B" : "#EF4444";
  const label = pct > 0.66 ? "NOMINAL" : pct > 0.33 ? "STRAINED" : "DEPLETED";

  // Semi-circle arc using pathLength=100 for easy proportional fill.
  const arcPath = "M 20 90 A 70 70 0 0 1 160 90";

  return (
    <div
      className="glass-panel rounded-2xl p-5 h-full flex flex-col"
      data-testid="metabolic-budget-gauge"
    >
      <h3 className="mono text-xs font-semibold uppercase tracking-widest text-cyan-400 mb-2">
        Recovery Budget · Bₜ
      </h3>
      <div className="flex-1 flex flex-col items-center justify-center">
        <svg viewBox="0 0 180 110" className="w-full max-w-[220px]">
          <path
            d={arcPath}
            fill="none"
            stroke="#1e293b"
            strokeWidth="14"
            strokeLinecap="round"
          />
          <path
            d={arcPath}
            fill="none"
            stroke={color}
            strokeWidth="14"
            strokeLinecap="round"
            pathLength="100"
            strokeDasharray={`${pct * 100} 100`}
            style={{ transition: "stroke-dasharray 0.6s ease, stroke 0.4s ease" }}
          />
          <text
            x="90"
            y="82"
            textAnchor="middle"
            className="mono"
            fontSize="30"
            fontWeight="800"
            fill={color}
          >
            {pct.toFixed(2)}
          </text>
          <text x="90" y="102" textAnchor="middle" className="mono" fontSize="9" fill="#64748b">
            0.00 — 1.00
          </text>
        </svg>
        <span
          className="mono text-[11px] font-semibold tracking-widest mt-1"
          style={{ color }}
        >
          {label}
        </span>
      </div>
    </div>
  );
};
